import {
	SET_ANALYTICS_OPTIN,
	SET_LANGUAGE,
	SET_LEFTNAV_OPEN,
	SET_FORCE_HIDE_MENU,
	SET_FORCE_HIDE_NAVBAR,
	SET_FORCE_HIDE_LANGUAGE_SWITCHER,
	SET_FORCE_HIDE_LEARN_HOME,
	SET_MAIN_CONTAINER_OVERLAY,
	SET_BACKGROUND_HOME,
} from '../types';

const initialState = {
	language: 'en',
	leftNavOpen: false,
	forceHideMenu: false,
	forceHideNavbar: false,
	forceHideLanguageSwitcher: false,
	forceHideLearnHome: false,
	mainContainerOverlayEnabled: false,
	backgroundHome: {},
	analyticsOptinInited: false,
};

export default function app(state = initialState, action: AppAction) {
	switch (action.type) {
		case SET_ANALYTICS_OPTIN:
			return Object.assign({}, state, {
				analyticsOptinInited: action.analyticsOptinInited,
			});
		case SET_LANGUAGE:
			return Object.assign({}, state, {
				language: action.langCookie,
			});

		case SET_LEFTNAV_OPEN:
			return Object.assign({}, state, {
				leftNavOpen: action.leftNavOpen,
			});

		case SET_FORCE_HIDE_MENU:
			return Object.assign({}, state, {
				forceHideMenu: action.forceHideMenu,
			});

		case SET_FORCE_HIDE_NAVBAR:
			return Object.assign({}, state, {
				forceHideNavbar: action.forceHideNavbar,
			});

		case SET_FORCE_HIDE_LANGUAGE_SWITCHER:
			return Object.assign({}, state, {
				forceHideLanguageSwitcher: action.forceHideLanguageSwitcher,
			});

		case SET_FORCE_HIDE_LEARN_HOME:
			return Object.assign({}, state, {
				forceHideLearnHome: action.forceHideLearnHome,
			});

		case SET_MAIN_CONTAINER_OVERLAY:
			return Object.assign({}, state, {
				mainContainerOverlayEnabled: action.mainContainerOverlayEnabled,
			});
		case SET_BACKGROUND_HOME:
			return Object.assign({}, state, {
				backgroundHome: action.backgroundHome,
			});
		default:
			return state;
	}
}
